import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { isEmpty, remove } from 'lodash';
import { Observable } from 'rxjs';
import { SailsSocketService } from '../../sails-socket';
import { Schedule } from '../schedule';
import { EditSchedule } from '../editschedule';
let ScheduleManagerService = class ScheduleManagerService {
    sails;
    schedules = new Map();
    schedulesByOrg = new Map();
    constructor(sails) {
        this.sails = sails;
    }
    getSchedules(org) {
        return new Observable((subscriber) => {
            let subscription;
            if (this.schedulesByOrg.has(org)) {
                subscriber.next(this.schedulesByOrg.get(org));
                subscriber.complete();
            }
            else {
                // load schedules for org
                subscription = this.sails.get(`/organization/${org}/schedules`)
                    .subscribe({
                    next: ({ data }) => {
                        const schedules = (data || []).map((sched) => {
                            const newSched = new Schedule(sched);
                            this.schedules.set(newSched.id, newSched);
                            return newSched;
                        });
                        this.schedulesByOrg.set(org, schedules);
                        subscriber.next(this.schedulesByOrg.get(org));
                        subscriber.complete();
                    },
                    error: (err) => {
                        subscriber.error(err);
                        subscriber.complete();
                    }
                });
            }
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    saveSchedule(schedule) {
        return new Observable((subscriber) => {
            let subscription;
            const changes = schedule.changes();
            if (isEmpty(changes)) {
                subscriber.error(new Error('no changes'));
                subscriber.complete();
            }
            else {
                const createOrUpdateObs = schedule.id ?
                    this.sails.put(`/schedule/${schedule.id}`, changes) :
                    this.sails.post('/schedule', changes);
                subscription = createOrUpdateObs
                    .subscribe({
                    next: ({ data: model }) => {
                        let found = this.schedules.get(model.id);
                        if (!found) {
                            const newSchedule = new Schedule(model);
                            this.schedules.set(newSchedule.id, newSchedule);
                            const orgList = this.schedulesByOrg.get(model.org) || [];
                            orgList.push(newSchedule);
                            this.schedulesByOrg.set(model.org, orgList);
                            found = newSchedule;
                            schedule.updateModel(newSchedule);
                        }
                        found.updateModel(model);
                        schedule.reset();
                        subscriber.next(schedule);
                        subscriber.complete();
                    },
                    error: (err) => {
                        subscriber.error(err);
                        subscriber.complete();
                    }
                });
            }
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    cloneForEdit(schedule) {
        return new EditSchedule(schedule);
    }
    getNewScheduleForOrg(org) {
        return new Schedule({ org });
    }
    getAssociatedModels(id) {
        return new Observable((subscriber) => {
            const subscription = this.sails.get(`/schedule/${id}/associated`)
                .subscribe({
                next: ({ data }) => {
                    subscriber.next(data);
                    subscriber.complete();
                },
                error: (err) => {
                    subscriber.error(err);
                    subscriber.complete();
                }
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    deleteSchedule(id) {
        return new Observable((subscriber) => {
            let subscription;
            const schedule = this.schedules.get(id);
            if (schedule) {
                subscription = this.sails.delete(`/schedule/${id}`)
                    .subscribe({
                    next: () => {
                        const orgList = this.schedulesByOrg.get(schedule.org);
                        if (orgList) {
                            remove(orgList, sched => sched.id === schedule.id);
                        }
                        subscriber.next(id);
                        subscriber.complete();
                    },
                    error: (err) => {
                        subscriber.error(err);
                        subscriber.complete();
                    }
                });
            }
            else {
                subscriber.error(new Error('Schedule not found'));
                subscriber.complete();
            }
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    static ctorParameters = () => [
        { type: SailsSocketService }
    ];
};
ScheduleManagerService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], ScheduleManagerService);
export { ScheduleManagerService };
